<template>
  <div>
    <v-row>
      <v-col md="3">
        <h3 class="primary--text"> Location: </h3>
      </v-col>
      <v-col>
        <h3>{{booking.capturedAddress}}</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3"><h3 class="primary--text">Booking number</h3></v-col>
      <v-col><h3>{{ booking.orderNumber.number }}</h3></v-col>
    </v-row>
    <v-row>
      <v-col md="3">
        <h3 class="primary--text">Date and time:</h3>
      </v-col>
      <v-col>
        <h3>{{ booking.preferredDate }} &nbsp; {{ booking.preferredTime === 'AM' ? 'AM' : 'PM' }}</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3"><h3 class="primary--text">Company:</h3></v-col>
      <v-col><h3>{{ booking.customer.companyName ? booking.customer.companyName : booking.customer.firstName + " " + booking.customer.lastName }}</h3></v-col>
    </v-row>
    <v-row>
      <v-col md="3"><h3 class="primary--text">Customer:</h3></v-col>
      <v-col><h3>{{ booking.customer.firstName + " " + booking.customer.lastName }}</h3></v-col>
    </v-row>
    <v-row v-if="booking.instructions">
      <v-col md="3"><h3 class="warning--text">Instructions:</h3></v-col>
      <v-col class="warning--text"><h3>{{ booking.instructions }}</h3></v-col>
    </v-row>
    <v-row>
      <v-col md="3">
        <h3 class="primary--text">Waste type:</h3>
      </v-col>
      <v-col>
        <h3>{{ booking.waste.name }}</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3">
        <h3 class="primary--text">Vehicle type:</h3>
      </v-col>
      <v-col>
        <h3>{{ booking.vehicle.name }}</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="4">
        <v-text-field
        label="Service note number #"
        dense
        outlined
        v-model="serviceNote"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3" v-if="!booking.arrival">
        <v-btn class="primary" v-on:click="arrival()"> 10 min away </v-btn>
      </v-col>
      <v-col md="3">
        <v-btn :disabled="this.disable" v-if="this.serviceNote.length > 1 && !this.mailSent" class="primary" v-on:click="umthiMail()"> Next </v-btn>
      </v-col>
      <v-col md="3">
        <v-btn v-if="this.serviceNote.length > 1 && this.mailSent" class="primary" v-on:click="changeStatus()"> {{ buttonText }} </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'DriverSchedule',
  props: {
    booking: Object
  },
  data() {
    return {
      timeStamp: new Date(),
      buttonText: 'Deliver',
      serviceNote: '',
      show: true,
      mailSent: false,
      disable: false
    }
  },
  computed: {
    fuelLevyPrice() {
      return this.$store.state.fuelLevy.fuelLevyPrice;
    }
  },
  methods:{
    //send umthi mail to customers when bin is delivered
    async umthiMail(){
      this.disable = true;
      if ((this.booking.status.type == 'DELIVERY' && !this.booking.status.locked && !this.booking.status.origin) || (this.booking.status.type == 'COLLECTION' && this.booking.vehicle.type == 'Truck')){
        let data = {
          customer: this.booking.customer.firstName + " " + this.booking.customer.lastName,
          email: this.booking.customer.emailAddress,
        };
        await this.$store.dispatch('addTreeNum', data);
        return this.mailSent = true;
      }
      else{
        return this.mailSent = true;
      }
    },
    async changeStatus() {
      // calculate fuel levy cost
      const cost = () => {
        let fuel = Number(this.booking.cost.fuelLevy ?? 0);
        let amount = Number(this.booking.cost.value);
        if (fuel === 0) {
          return amount + this.fuelLevyPrice;
        }
        else {
          return (amount - fuel) + this.fuelLevyPrice;
        }
      };

      if (this.booking.status.type === 'EXCHANGE') {
        await this.$store.dispatch('updateBooking', {
          id: this.booking.id,
          arrival: '',
          timeStamp: this.timeStamp,
          serviceNote: this.serviceNote,
          cost: {
            ...this.booking.cost,
            fuelLevy: this.fuelLevyPrice,
            value: cost()
          },
          status: { type: 'EXCHANGE', status: 'DISPOSING' }
        });
      } 
      if (this.booking.status.type === 'COLLECTION') {
        await this.$store.dispatch('updateBooking', {
          id: this.booking.id,
          arrival: '',
          timeStamp: this.timeStamp,
          serviceNote: this.serviceNote,
          status: { type: 'COLLECTION', status: 'DISPOSING' }
        });
      } 
      if (this.booking.status.type === 'DELIVERY') {
        await this.$store.dispatch('updateBooking', {
          ...this.booking,
          serviceNote: this.serviceNote,
          arrival: '',
          timeStamp: this.timeStamp,
          cost: {
            ...this.booking.cost,
            fuelLevy: this.fuelLevyPrice,
            value: cost()
          },
          status: {
            ...this.booking.status,
            status: 'DROPPED'
          }
        }); 
      }
    },
    async arrival(){
      await this.$store.dispatch('updateBooking', {
        id: this.booking.id,
        arrival: {
          time: '10min',
          locked: true
        }
      })
      //send customer sms when driver is 10 min away
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        'number': this.booking.customer.mobile,
        'location': this.booking.capturedAddress,
        'customerId': this.booking.customer.id,
        'bookingNumber': this.booking.orderNumber.number, 
      });
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };
      await fetch("https://us-central1-wrapp-waste.cloudfunctions.net/arrivalSms", requestOptions)
      .catch(error => {
        console.log('error', error);
      });
    }

  },
  mounted() {
    if (this.booking.status.type === 'EXCHANGE')
      this.buttonText = 'Exchange';
    else if (this.booking.vehicle.type.toLowerCase().includes('truck'))
      this.buttonText = 'Load';
    else if (this.booking.status.type === 'COLLECTION')
      this.buttonText = 'Collect';

    if (this.booking.status.status == 'SCHEDULED' && this.booking.arrival){
      this.show = false;
      //track driver when he's 10 min away
      if(navigator.geolocation){
        navigator.geolocation.watchPosition((position) => {
          //sets timeInterval to every after 10 seconds, before sending location update
          setInterval(() => {
            this.$store.dispatch('updateDriverLocation', {
              id: this.booking.id,
              arrival: {
                time: '10min',
                locked: false
              },
              driver: {
                lat: position.coords.latitude,
                long: position.coords.longitude,
              }
            })

          }, 10000);
        })
      }
      else{
        alert('Please allow location tracking on your device');
      }
    }
  },
}
</script>

<style scoped>

</style>